<template>
	<base-modal
		ref="$modal"
		:title="props.title"
		width="max-content"
		max-width="90vw"
		height="max-content"
	>
		<div class="parameter-expand">
			<table
				class="dialog-table"
				ref="$table"
			>
				<parameter-inline
					v-if="$table"
					is-root
					is-table
					:editable="props.editable"
					:id="props.id"
					:model-value="props.modelValue"
					:token-styles="props.tokenStyles"
					:show-custom="false"
					:value-set-from-instance="true"
					:context-trigger="$table"
					:create-mode="false"
					:show-field-label="props.showFieldLabel"
					@update:modelValue="(value: ParameterInstanceContainer[]) => emit('update:modelValue', value)"
				/>
			</table>
		</div>
	</base-modal>
</template>

<script setup lang="ts">
import { ref } from "vue";
import BaseModal from "@/components/common/modal/BaseModal.vue";
import ParameterInline from "@/components/multiedit/temporary/ParameterInline.vue";
import { ParameterInstanceContainer } from "@/models/interfaces/parameters/parameter-models";

type ParameterExpandModalProps = {
	id: string,
	title: string,
	modelValue: ParameterInstanceContainer[],
	editable?: boolean,
	tokenStyles?: Record<string, string>,
	showFieldLabel?: boolean,
}

const props = withDefaults(defineProps<ParameterExpandModalProps>(), {
	editable: false,
	showFieldLabel: true,
})

const emit = defineEmits<{
	(e: 'update:modelValue', value: ParameterInstanceContainer[]): void,
}>()

const $modal = ref<InstanceType<typeof BaseModal> | null>(null)
// Таблица нужна параметру как якорь контекстного меню, поэтому он рендерится вторым проходом
const $table = ref<HTMLElement | null>(null)

const onOpen = () => $modal.value?.onOpen()
const onClose = () => $modal.value?.onClose()

defineExpose({ onOpen, onClose })
</script>

<style scoped lang="scss">
.parameter-expand {
	min-width: 55vw;
	min-height: 0;
	padding: 4px 12px 12px 12px;
	overflow: auto;
	box-sizing: border-box;
}

.parameter-expand .dialog-table {
	width: max-content;
	min-width: 100%;
	max-width: none;
}

.parameter-expand :deep(.dialog-table td) {
	border-top-width: 0;
}

.parameter-expand :deep(.dialog-table tr + tr > td) {
	border-top-width: 1px;
}

.parameter-expand :deep(.dialog-table .parameter-table td) {
	border-top-width: 0;
}
</style>
